'use client'

import { useMemo, type PropsWithChildren } from 'react'

import { SpaceLayoutClient as SharedSpaceLayoutClient } from '@/components/space/space-layout-client'
import type { SceneID } from '@/enums/agent'
import type { ModelConfigItem } from '@/lib/api/models/config'
import { useModelStore } from '@/stores'

interface SpaceLayoutClientProps extends PropsWithChildren {
  defaultOpen?: boolean
}

/** Match MiniMax H3 from /v1/lyart/models by name/shortName */
export function findMiniMaxH3Model(modelConfigs: ModelConfigItem[]): ModelConfigItem | undefined {
  return modelConfigs.find(
    m => /minimax\s*h3/i.test(m.name) || /minimax\s*h3/i.test(m.shortName ?? '')
  )
}

export function findMiniMaxH3SceneId(modelConfigs: ModelConfigItem[]): SceneID | undefined {
  return findMiniMaxH3Model(modelConfigs)?.sceneId
}

/**
 * MiniMax H3 page layout client.
 * Uses shared SpaceLayoutClient with basePath /minimax-h3；
 * 默认模型从 modelConfigs 按名称解析（接口下发 sceneId）
 */
export const SpaceLayoutClient = ({ children, defaultOpen = true }: SpaceLayoutClientProps) => {
  const modelConfigs = useModelStore(s => s.modelConfigs)
  const defaultModelId = useMemo(() => findMiniMaxH3SceneId(modelConfigs), [modelConfigs])

  return (
    <SharedSpaceLayoutClient
      config={{ basePath: '/minimax-h3', defaultModelId }}
      defaultOpen={defaultOpen}
    >
      {children}
    </SharedSpaceLayoutClient>
  )
}
